import {stringToDashed} from 'cl-automation-utils';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import * as Colors from 'material-ui/styles/colors';
import _ from 'lodash';
let instance;

export const styles = {
  dialogBody: {
    padding: 0,
    fontSize: 16,
    color: Colors.grey600,
    width: 870,
    maxWidth: 870,
  },
  dialogContent: {
    width: 870,
    maxWidth: 870,
  },
  dialogHeader: {
    fontSize: 24,
    color: 'white',
    height: 60,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  dialogFooter: {
    width: '100%',
    height: '70px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  infoBoxIcon: {
    fontSize: 30,
    marginLeft: 15,
    marginRight: 20,
  },
  reportErrorButton: {
    margin: 20,
  },
  reportErrorButtonLabel: {
    color: 'black',
  },
  button: {
    margin: 20,
  },
  errorMessageContainer: {
    margin: 20,
  },
  closeIcon: {
    color: 'white',
  },
};

const LEVEL_INFO = 'info';
const LEVEL_ERROR = 'error';

const defaultProps = {
  open: false,
  level: LEVEL_INFO,
  buttonLabel: 'got it',
};

export default class InfoDialog extends Component {
  constructor(props) {
    super();
    if (!instance) {
      instance = this;
    }
    this.state = {...props};
  }

  static info(props) {
    const {setOpen} = instance.props;
    instance.setState({..._.mapValues(instance.state, () => undefined), ...defaultProps, ...props});
    setOpen(true);
  }

  handleOk = () => {
    const {setOpen} = this.props;
    const {action, onClose} = this.state;
    if (action) {
      action();
    }
    setOpen(false);
    if (onClose) {
      onClose();
    }
  };

  handleCancel = performSecondaryAction => {
    const {setOpen} = this.props;
    const {secondaryAction, onClose} = this.state;
    setOpen(false);
    if (onClose) {
      onClose();
    }
    if (secondaryAction && performSecondaryAction) {
      secondaryAction();
    }
  };

  render() {
    const {level, title, message, buttonLabel, cancelButtonLabel} = this.state;
    let backgroundColor;
    if (level === LEVEL_ERROR) {
      backgroundColor = Colors.red900;
    } else {
      backgroundColor = Colors.lightGreen800;
    }
    let {icon} = this.state;
    if (icon) {
      icon = React.cloneElement(icon, {...icon.props, style: {...styles.infoBoxIcon, height: 30, width: 30}});
    } else {
      icon = (
        <FontIcon style={styles.infoBoxIcon} color={'white'} className="material-icons">
          error
        </FontIcon>
      );
    }
    return (
      <Dialog bodyStyle={styles.dialogBody} contentStyle={styles.dialogContent} open={this.props.open}>
        <div style={{...styles.dialogHeader, backgroundColor}}>
          {icon}
          {title}
          <span style={{flexGrow: 1}} />
          <IconButton id="cla-btn-x" onClick={this.handleCancel.bind(this, false)} iconStyle={styles.closeIcon}>
            <FontIcon className="material-icons">close</FontIcon>
          </IconButton>
        </div>
        <div style={styles.errorMessageContainer}>{message}</div>
        <div style={{...styles.dialogFooter, justifyContent: cancelButtonLabel ? 'space-between' : 'center'}}>
          {cancelButtonLabel && (
            <FlatButton
              id="cla-btn-cancel"
              style={styles.button}
              label={cancelButtonLabel}
              onClick={this.handleCancel.bind(this, true)}
            />
          )}
          {buttonLabel && (
            <FlatButton
              id={`cla-btn-${stringToDashed(buttonLabel)}`}
              primary
              style={styles.button}
              label={buttonLabel}
              onClick={this.handleOk}
            />
          )}
        </div>
      </Dialog>
    );
  }
}

InfoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.node,
  level: PropTypes.oneOf([LEVEL_INFO, LEVEL_ERROR]),
  icon: PropTypes.node,
  buttonLabel: PropTypes.node, // set to null to hide primary button
  cancelButtonLabel: PropTypes.node,
  action: PropTypes.func,
  secondaryAction: PropTypes.func,
};

InfoDialog.defaultProps = defaultProps;
